import { CheckboxInputField } from '../../../Common/Form'
import { Field, FormValueSelector } from '../../../Common/forms'
import { ProposalSection } from '@vzmi/shp_shared_compo'
import { getSectionVisibleFieldName } from '../helper'
import styles from './index.css'

const SectionTitle = props => {
  const { title, sectionKey, readOnly, withoutCheckbox } = props
  if (withoutCheckbox) {
    return title
  }

  const prefixTitle = (
    <>
      同時修改
      {title}
    </>
  )
  return (
    <Field
      component={CheckboxInputField}
      name={getSectionVisibleFieldName(sectionKey)}
      className={styles.sectionToggle}
      label={prefixTitle}
      readOnly={readOnly}
    />
  )
}

const AnchorProposalSection = props => {
  const {
    component: Component,
    customTitle = title => title,
    anchor,
    description,
    readOnly,
    withoutCheckbox,
    ...restProps
  } = props
  const sectionKey = anchor.link
  return (
    <ProposalSection
      id={sectionKey}
      name={sectionKey}
      title={(
        <SectionTitle
          title={customTitle(anchor.sectionTitle)}
          sectionKey={sectionKey}
          readOnly={readOnly}
          withoutCheckbox={withoutCheckbox}
        />
      )}
      description={description}
    >
      <FormValueSelector
        selector={select => ({
          // redux form init 時 section 預設都是 visible
          // 當 user checkbox 取消時才會隱藏 section
          isSectionVisible: !!select(getSectionVisibleFieldName(sectionKey))
        })}
      >
        {({ isSectionVisible }) => {
          if (!isSectionVisible) {
            return null
          }

          return (
            <Component
              readOnly={readOnly}
              {...restProps}
            />
          )
        }}
      </FormValueSelector>
    </ProposalSection>
  )
}

export default AnchorProposalSection
